<template>
  <div class="app-container">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select
          v-model="queryParam.commId"
          clearable
          filterable
          placeholder="请选择小区"
        >
          <el-option
            v-for="item in optionList"
            :key="item.id"
            :label="item.commName"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-date-picker
          v-model="publish_time"
          type="daterange"
          align="right"
          start-placeholder="活跃时间起"
          end-placeholder="活跃时间止"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd"
        />
      </div>
      <div class="shaixuan-item">
        <el-button
          type="primary"
          size="mini"
          style="background: #1890ff; border-color: #1890ff"
          @click="searchClick"
          icon="el-icon-search"
        >
          查询
        </el-button>
        <el-button
          type="primary"
          size="mini"
          style="background: #e6a700; border-color: #e6a700"
          @click="exportData"
          icon="el-icon-document-checked"
          :loading="exportLoading"
        >
          导出
        </el-button>
      </div>
    </div>

    <div class="common-section-bg common-section-body">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        size="mini"
        style="width: 100%; min-height: 300px"
      >
        <el-table-column prop="user.name" label="用户姓名" min-width="140" />
        <el-table-column prop="user.phone" label="手机号码" min-width="140" />
        <el-table-column prop="resourceName" label="资源名称" min-width="220" />
        <el-table-column prop="resourceId" label="资源编号" min-width="140" />
        <el-table-column prop="date" label="活跃时间" min-width="140" />
      </el-table>
      <pagination
        v-show="total"
        :total="total"
        :page.sync="queryParam.page"
        :limit.sync="queryParam.size"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import fetch from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination";

export default {
  data() {
    return {
      publish_time: [],
      optionList: [],
      queryParam: {
        commId: "",
        datebegin: "",
        dateend: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      exportLoading: false,
      tableData: [],
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.queryParam.commId = this.$route.query.id || "";
  },
  mounted() {
    this.getSelectCity();
    this.getList();
  },
  methods: {
    syncDateRange() {
      if (this.publish_time && this.publish_time.length === 2) {
        this.queryParam.datebegin = this.publish_time[0];
        this.queryParam.dateend = this.publish_time[1];
      } else {
        this.queryParam.datebegin = "";
        this.queryParam.dateend = "";
      }
    },
    getSelectCity() {
      fetch.select({}).then((res) => {
        if (res.code === 200) {
          this.optionList = res.result;
        }
      });
    },
    searchClick() {
      this.queryParam.page = 1;
      this.getList();
    },
    getList() {
      this.syncDateRange();
      this.listLoading = true;
      fetch.huoyueList(this.queryParam)
        .then((res) => {
          this.listLoading = false;
          this.tableData = (res.result && res.result.list) || [];
          this.total = (res.result && res.result.total) || 0;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    exportData() {
      this.syncDateRange();
      if (!this.queryParam.commId) {
        this.$message.warning("请先选择小区");
        return;
      }
      this.exportLoading = true;
      fetch.exportHuoyueList(this.queryParam)
        .then((res) => {
          this.exportLoading = false;
          if (res.code === 200 && res.result) {
            window.open(res.result);
          } else {
            this.$message.error(res.message || "导出失败");
          }
        })
        .catch((err) => {
          this.exportLoading = false;
          this.$message.error(err || "导出失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
